import React, { useEffect } from "react";
import "./memberProfile.css";
import { Link } from "react-router-dom";
import * as Moment from "moment";
import {
  // Element,
  // Events,
  animateScroll as scroll
  // scrollSpy,
  // scroller
} from "react-scroll";
import styled from "styled-components";
import { ReactComponent as _BackIcon } from "../../assets/left-arrow.svg";

import { ReactComponent as _EditIcon } from "../../assets/edit.svg";
import KeikenMonths from "../memberKeiken/keikenMonths";

const EditIcon = styled(_EditIcon)`
  width: 20px;
  height: 20px;

  color: #fff;
  fill: currentColor;
  transition: all 200ms;

  div &:hover {
    transform: scale(1.3);
  }
`;

const BackIcon = styled(_BackIcon)`
  width: 20px;
  height: 20px;

  color: #fff;
  fill: currentColor;
  transition: all 200ms;

  div &:hover {
    transform: scale(1.3);
  }
`;

const RanksWrapper = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 0.8em;
  margin: 20px 20px;
`;

const Label = styled.div`
  font-size: 18px;
  color: #00224d;
  font-weight: bold;
  margin-bottom: 10px;
  margin-left: 10px;
`;
const KeikenWrapper = styled.div`
  padding: 10px;
`;

const MemberProfile = props => {
  // const [editMode, setEditMode] = useState(false);

  useEffect(() => {
    console.log("Component did mount - memberprorfile");
    console.log("props:", props);
    scroll.scrollToTop();
  }, []);

  useEffect(() => {
    // Check if members data has been loaded if not then load members data.
    if (props.firebaseReady && !props.membersLoaded) {
      console.log("LOADING MEMBERS NOW!");
      props.loadMembers();
    }
    console.log("props:", props);

    if (!props.isAuthenticated) {
      window.history.pushState(null, null, "/login");
      // window.history.go();
      window.location.reload();
    }
  }, [props.firebaseReady, props.membersLoaded]);

  const goBack = () => {
    window.history.back();
  };

  // console.log("member ranks: ", props.memberRanks);
  const memberRanks = props.memberRanks.map(mr => {
    // console.log("mr ID:", mr.ID);
    return (
      <div className="rank-item" key={mr.ID}>
        <img
          className="rank-image"
          src={"/" + mr.level.LevelImage}
          alt="levelimage"
        />
        <div className="date-wrapper">
          <div className="date">{Moment(mr.RankDate).format("DD-MM-YYYY")}</div>
          <div className="experience">{Moment(mr.RankDate).fromNow()}</div>
        </div>
        <div className="title-wrapper">
          <div className="title">{mr.level.LevelTitle}</div>
          <div className="descr">{mr.level.LevelDescription}</div>
        </div>
      </div>
    );
  });

  const currentRank =
    props.memberRanks[0] && props.memberRanks[0].level ? (
      <div className="current-rank">
        <strong>
          {props.member.Title ? <span>{props.member.Title}, </span> : null}{" "}
          {props.memberRanks[0].level.LevelTitle}
        </strong>
      </div>
    ) : null;

  const linkToMembers = goBack ? (
    <button className="back-button" onClick={goBack}>
      <BackIcon />
    </button>
  ) : (
    <Link to="/">
      <BackIcon />
    </Link>
  );

  if (!props.member) {
    return null;
  } else {
    const memberImage = props.member.ImageUrl ? (
      <div className="memberprofile-image-wrapper">
        <img src={props.member.ImageUrl} />
      </div>
    ) : null;

    return (
      <div className="member-profile">
        <div className="nav-wrapper">
          <div className="back-wrapper">{linkToMembers}</div>
          <Link className="editUser" to={`/edit/member/${props.member.ID}`}>
            <EditIcon />
          </Link>
        </div>
        <div className="header-wrapper">
          {memberImage}
          <h2>
            {props.member.FirstName} {props.member.LastName}
          </h2>
          {currentRank}
          <p>{props.member.TeamName}</p>
          <p>{props.member.Role}</p>
          <p>{props.member.ExtraRole}</p>
        </div>
        <div className="main-content-wrapper">
          <div className="member-data">
            <label>ID</label>
            <p style={{ color: "#555", fontSize: "16px" }}>{props.member.ID}</p>
            <label>Adresse</label>
            <p>
              {props.member.Address}
              <br />
              {props.member.Postno}
              <span> {props.member.City}</span>
            </p>
            <label>Telefon nummer</label>
            <p>
              <a href={"tel:" + props.member.Phone}>{props.member.Phone}</a>
            </p>
            <label>Email</label>
            <p>{props.member.Email}</p>
            <label>Født</label>
            <p>
              {Moment(props.member.Birthdate).format("DD. MMMM YYYY")},{" "}
              {Moment().diff(Moment(props.member.Birthdate), "years", false)} år
            </p>
            <label>Startet</label>
            <p>
              {Moment(props.member.Started).format("DD. MMMM YYYY")},{" "}
              {Moment(props.member.Started).fromNow()}
            </p>
            <label>Evt. Forældre</label>
            <p>{props.member.ParentName}</p>
            <label>Kommentar</label>
            <p>{props.member.Comment}</p>
          </div>

          <Label>Keiken</Label>
          <KeikenWrapper>
            <KeikenMonths activities={props.member.Activities} />
          </KeikenWrapper>

          <Label>Gradueringer</Label>
          <RanksWrapper>
            {memberRanks}
            <div style={{ flex: "0 0 200px" }} />
          </RanksWrapper>
        </div>
      </div>
    );
  }
};

export default MemberProfile;
